import Vue from 'vue';
import Component from 'vue-class-component';

import ProductBlock from 'common/components/ProductBlock';
import Rating from 'common/components/Rating';
import currency from 'common/filters/currency';
import OptionalRouterLink from 'ecommerce/components/OptionalRouterLink/OptionalRouterLink.vue';

import deliveryIcon from 'common/icons/delivery-person.svg';
import takeAwayIcon from 'common/icons/take-away.svg';
import receptionBell from 'common/icons/reception-bell.svg';

Vue.filter('currency', currency);

@Component({
  components: {
    ProductBlock,
    Rating,
    OptionalRouterLink,
    DiscountLabel: () => import('common/components/DiscountLabel'),
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    box: {
      type: Object,
      required: false,
    },
    availableHours: {
      type: Array,
      required: false,
      default: () => [],
    },
    productTitle: {
      type: String,
      default: 'Experiencia:',
    },
    bigBlock: {
      type: Boolean,
      default: true,
      description:
        'Change styles of the Block. True if 3 blocks will be displayed in a row',
    },
    showHeart: {
      type: Boolean,
      default: true,
    },
    showRating: {
      type: Boolean,
      default: true,
    },
    showLocation: {
      type: Boolean,
      default: true,
    },
    boxColour: {
      type: String,
      required: false,
    },
    campaignColor: {
      type: String,
      required: false,
    },
    campaignSlug: {
      type: String,
      required: false,
    },
    showPrice: {
      type: Boolean,
      required: false,
    },
    preventClick: {
      type: Boolean,
      required: false,
      default: false,
    },
    showOnlineReservationLabel: {
      type: Boolean,
      default: false,
    },
  },
})
export default class NewActivityBlockComponent extends Vue {
  windowWidth = null;
  receptionBell = receptionBell;

  created() {
    window.addEventListener('resize', this.recalculateWidth);
    this.recalculateWidth();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.recalculateWidth);
  }

  recalculateWidth() {
    this.windowWidth = window.innerWidth;
  }

  get description() {
    if (this.activity.short_description) {
      return this.activity.short_description;
    } else if (this.activity.description) {
      return this.activity.description;
    }
    return '';
  }

  get activityClicked() {
    let newRoute = {};
    if (this.$route.name === 'boxActivity') {
      newRoute = {
        name: 'boxActivity',
        params: {
          activitySlug: this.activity.slug,
          boxSlug: this.box.slug,
          categorySlug: this.activity.category.slug,
        },
      };
    } else {
      newRoute = { path: this.activity.product_url };
    }
    if (this.campaignSlug) {
      newRoute.query = {
        ...newRoute.query,
        campaignSlug: this.campaignSlug,
      };
    }
    return newRoute;
  }

  get activityLocation() {
    const { partneractivity, comboactivity } = this.activity;

    const formatLocation = locations => {
      if (locations[0]?.delivery_in_all_country) {
        return 'Envío a todo el país';
      }
      if (locations.length > 1) {
        return 'Múltiples localidades';
      }
      return `${locations[0]?.sublocation}, ${locations[0]?.province.name}`;
    };

    const formatComboLocations = locations => {
      const formatter = new Intl.ListFormat('es', { type: 'conjunction' });
      const uniqueLocations = locations
        .map(location => location.sublocation)
        .filter((location, index, array) => array.indexOf(location) === index);
      return formatter.format(uniqueLocations);
    };

    if (this.activity.locations) {
      if (this.activity.activity_type === 'online') {
        return 'Experiencia online';
      }
      return formatLocation(this.activity.locations);
    }

    if (partneractivity?.locations) {
      if (partneractivity.activity_type === 'online') {
        return 'Experiencia online';
      }
      return formatLocation(partneractivity.locations);
    }

    if (comboactivity?.locations) {
      return formatComboLocations(comboactivity.locations);
    }

    return '';
  }

  get ratingFontSize() {
    return this.windowWidth > 768 ? '16px' : '14px';
  }

  get ratingStarSize() {
    return this.windowWidth > 768 ? '--small' : '--tiny';
  }

  get showFullPrice() {
    return (
      this.activity.price_without_discount &&
      Number(this.activity.price_without_discount) > Number(this.activity.price)
    );
  }

  get isTravel() {
    return this.activity.__typename === 'TravelActivityType';
  }

  get activityTypeTag() {
    switch (this.activity.activity_type) {
      case 'delivery':
        return ['Delivery', deliveryIcon];
      case 'take_away':
        return ['Take Away', takeAwayIcon];
      default:
        return null;
    }
  }
}
